<template>
  <div class="details">
    <div v-if="config.approach" class="detailRow">
      <span class="detailLabel">APPROACH</span>
      <span class="detailValue approach">{{ config.approach }}</span>
    </div>
    <div v-if="hasPersonas" class="detailRow">
      <span class="detailLabel">PERSONAS</span>
      <span class="personaChips">
        <span v-for="(p, i) in personaNames" :key="i" class="badge">{{ p }}</span>
      </span>
    </div>
    <div class="detailRow">
      <span class="detailLabel">CONTACT LIMIT</span>
      <span class="detailValue">{{ hasContactLimit ? config.max_contacts_per_account : 'Unlimited' }}</span>
    </div>
    <div class="detailRow">
      <span class="detailLabel">CADENCE</span>
      <span class="detailValue">Active {{ config.active_days ?? 1 }}d &middot; Opportunistic {{ config.opportunistic_days ?? 7 }}d</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  config: Record<string, any>
}>()

const hasPersonas = computed(() => {
  const list = props.config.personas || []
  return list.length > 0
})

const hasContactLimit = computed(() => {
  const v = props.config.max_contacts_per_account
  return v !== null && v !== undefined && v !== ''
})

const personaNames = computed(() => {
  const list = props.config.personas || []
  return list.map((p: any) => p.name || 'Unnamed')
})
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.detailRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
}
.detailValue {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
}
.detailValue.approach {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.personaChips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}
</style>
